/* Location Parameters */
export const CHIRP_PRODUCTION_DOMAIN = 'chirp.research.exeter.ac.uk';

// As suggested by Aaron Jones on 2023-09-19. 
export const FAR_DEFAULT_SIGNIFICANCE_THRESHOLD = 3.9E-7;